import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import avatar5 from '../../assets/img/avatar_5.svg';
import ProjectDropdown from '../../components/CommonFilter/ProjectDropdown';
import AddSingleMemberDropdown from '../../components/CustomDropdown/AddSingleMemberDropdown';
import CreateProjectDropdown from '../../components/DropdownStyle/CreateProjectDropdown';
import FilterDropDownStyle from '../../components/DropdownStyle/FilterDropDownStyle';
import Select from '../../components/ReactSelectDropdown';
import { filterOption } from '../../components/ReactSelectDropdown/ReactSelectDropdown';
import SearchWithButton from '../../components/Search/SearchWithButton';
import DatePicker from '../../components/SingleDatePicker/SingleDatePicker';
import {
  FilterLabel,
  FormAlert,
  InputField,
  InputLabel,
  InputWithLabelSection,
} from '../../styledComponents/common';
import { FilterContainer } from '../../styledComponents/tasks';
import { DateRangeContainer } from 'custom_modules/Dashboard/dashboardStyles';
import ReactDateRangePicker from 'components/ReactDateRangePicker/ReactDateRangePicker';
import { RedStar } from 'styledComponents/members';
import CreatableSelect from 'react-select/creatable';
import ButtonTextLoader from 'components/Loaders/ButtonTextLoader';

const SelfEvaluationFilter = props => {
  const { t } = useTranslation();
  const [officeOptions, setOfficeOptions] = useState([]);
  const [selectedDate, setSelectedDate] = useState({
    // startDate: moment('2025-05-06')
    startDate: moment().subtract(30, 'days'),
    endDate: moment()
  });

  const roleOptions = [
    {
      label: t('all_roles'),
      value: null,
    },
    {
      label: 'Admin',
      value: 'admin',
    },
    {
      label: 'GM',
      value: 'gm',
    },
    {
      label: 'AGM',
      value: 'agm',
    },
    {
      label: 'Supervisor',
      value: 'supervisor',
    },
    {
      label: 'Employee',
      value: 'employee',
    },
  ];

  const {
    getOfficesShortList,
    officesShortList,
    selectedOffice,
    selectOffice,
    handleSearchByName,
    handleClearSearch,
    searchTerm,
    onSearchTermChange,
    userCodeSearchTerm,
    onUserCodeSearchTermChange,
    handleSearchByUserCode,
    handleClearUserCodeSearch,
    selectedRole,
    onRoleChange,
    isMemberNameLoading,
    memberOptions,
    selectedMember,
    onMemberNameChange,
    saveErrors,
    onDateRangeChange,
  } = props;

  useEffect(() => {
    if (officesShortList && officesShortList.length > 0) {
      let newArr = [];
      officesShortList.forEach((office, i) => {
        newArr.push({
          label: office.name,
          value: office.id,
        });
      });
      setOfficeOptions(newArr);
    }
  }, [officesShortList]);

  // Initialize with last 7 days
  useEffect(() => {
    if (onDateRangeChange) {
      onDateRangeChange(selectedDate);
    }
  }, []);

  const selectLastWeek = () => {
    const newDateRange = {
      startDate: moment().subtract(7, 'days'),
      endDate: moment()
    };
    setSelectedDate(newDateRange);
    if (onDateRangeChange) {
      onDateRangeChange(newDateRange);
    }
  };

  const selectLastMonth = () => {
    const newDateRange = {
      startDate: moment().subtract(30, 'days'),
      endDate: moment()
    };
    setSelectedDate(newDateRange);
    if (onDateRangeChange) {
      onDateRangeChange(newDateRange);
    }
  };

  const handleDatesChange = (dateRange) => {
    setSelectedDate(dateRange);
    if (onDateRangeChange) {
      onDateRangeChange(dateRange);
    }
  };

  const onDateApply = () => {
    if (onDateRangeChange) {
      onDateRangeChange(selectedDate);
    }
  };


  return (
    <FilterContainer
      columns={
        localStorage.getItem('user_role') === 'admin'
          ? '160px 340px 250px 260px 260px'
          : '340px 250px 260px 260px'
      }
      gap="15px"
    >
      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('office')}</FilterLabel>

          <Select
            isSearchable
            value={selectedOffice}
            options={officeOptions}
            placeholder="Select Office..."
            onChange={e => {
              selectOffice(e);
            }}
            styles={CreateProjectDropdown()}
            // clearable
            filterOption={filterOption}
          />
        </InputWithLabelSection>
      )}

      <InputWithLabelSection>
        <InputLabel>
          {t('member_name')}
        </InputLabel>
        <CreatableSelect
          isSearchable
          isClearable
          type="text"
          placeholder={
            isMemberNameLoading ? (
              <ButtonTextLoader
                color="#fff"
                loadingText=""
                size={4}
              ></ButtonTextLoader>
            ) : (
              t('type_member_name')
            )
          }
          value={selectedMember}
          options={memberOptions}
          onChange={e => onMemberNameChange(e)}
          styles={CreateProjectDropdown()}
        />
        {saveErrors && saveErrors['memberName'] && (
          <FormAlert>{saveErrors['memberName']}</FormAlert>
        )}
      </InputWithLabelSection>

      {localStorage.getItem('user_role') === 'admin' && (
        <InputWithLabelSection>
          <FilterLabel>{t('role')}</FilterLabel>

          <Select
            isSearchable
            value={selectedRole}
            options={roleOptions}
            placeholder={t('select_role')}
            onChange={e => {
              onRoleChange(e);
            }}
            styles={CreateProjectDropdown()}
          />
        </InputWithLabelSection>
      )}

      <InputWithLabelSection>
        <FilterLabel>{t('date_range')}</FilterLabel>
        <ReactDateRangePicker
          startDate={selectedDate.startDate}
          startDateId="custom-date-range-start-date"
          endDate={selectedDate.endDate}
          endDateId="custom-date-range-end-date"
          onDatesChange={handleDatesChange}
          dateDisplayFormat="DD/MM/YYYY"
          onDateSelect={onDateApply}
          selectLastWeek={selectLastWeek}
          selectLastMonth={selectLastMonth}
        />
      </InputWithLabelSection>
    </FilterContainer>
  );
};

export default SelfEvaluationFilter;
